export const GROUPS_EMAILS = 1;

export const INDIVIDUAL_EMAILS = 2;

export const FRIENDS_EMAILS = 3;
